import { render, staticRenderFns } from "./Tarifas_actividades.vue?vue&type=template&id=0b4cb6ff"
import script from "./Tarifas_actividades.vue?vue&type=script&lang=js"
export * from "./Tarifas_actividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports